import Reveal from "@/components/primitives/Reveal";
import { partnerProcess } from "@/data/partners";

export default function PartnerProcess() {
  return (
    <ol className="grid gap-4 sm:grid-cols-3">
      {partnerProcess.map((s, i) => {
        const Icon = s.icon;
        return (
          <li key={s.title}>
            <Reveal delay={i * 0.08} className="h-full">
              <div className="glass relative flex h-full flex-col gap-3 rounded-2xl p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand/15 text-sm font-semibold text-electric">
                    {i + 1}
                  </span>
                  <Icon className="h-5 w-5 text-electric" aria-hidden="true" />
                </div>
                <h3 className="text-base font-semibold tracking-tight text-fg">
                  {s.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted">{s.text}</p>
              </div>
            </Reveal>
          </li>
        );
      })}
    </ol>
  );
}
